import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Text, Header, Actions, Link } from '@gasbuddy/react-components';
import { noop } from '../../../lib/utils';
import { FavoriteListPropType } from '../../prop-types/favoriteList';
import FavoriteListsDropdown from '../FavoriteListsDropdown';
import sortFavoriteLists from '../../../lib/utils/sortFavoriteLists';

export default function AddStationToFavorites({
  stationId,
  favoriteLists,
  onAddStationToFavorites,
  onCancel,
  error,
}) {
  const [favoriteListId, setFavoriteListId] = useState(() => {
    const sortedLists = sortFavoriteLists(favoriteLists);
    return sortedLists.length && sortedLists[0].id;
  });

  const handleAddStationToFavorites = useCallback(() => {
    onAddStationToFavorites(favoriteListId, stationId);
  }, [favoriteListId, stationId, onAddStationToFavorites]);

  const handleFavoriteListChange = useCallback((list) => {
    if (list) {
      setFavoriteListId(list.id);
    }
  }, []);

  return (
    <React.Fragment>
      <Header as="h3">Choose a list to add this station to</Header>
      <FavoriteListsDropdown
        value={favoriteListId}
        favoriteLists={favoriteLists}
        onChange={handleFavoriteListChange}
      />
      {!!error && (
        <Text as="p" color="orange">
          {error}
        </Text>
      )}
      <br />
      <Actions>
        <Actions.Button
          primary
          fluid
          onClick={handleAddStationToFavorites}
          disabled={!favoriteListId}
          desktop={6}
        >
          Add to List
        </Actions.Button>
        <Actions.Action>
          <Link uppercase onClick={onCancel}>
            Cancel
          </Link>
        </Actions.Action>
      </Actions>
    </React.Fragment>
  );
}

AddStationToFavorites.propTypes = {
  stationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  favoriteLists: PropTypes.arrayOf(FavoriteListPropType),
  onAddStationToFavorites: PropTypes.func,
  onCancel: PropTypes.func,
  error: PropTypes.string,
};

AddStationToFavorites.defaultProps = {
  favoriteLists: [],
  onAddStationToFavorites: noop,
  onCancel: noop,
  error: undefined,
};
